import React from 'react';
import Icon from '../../../components/AppIcon';

const DishInfoOverlay = ({ 
  dishName, 
  price, 
  category, 
  servingSize,
  calories,
  prepTime 
}) => {
  return (
    /* top-16 = 64px clears the 44px back button (top-3 = 12px + 44px = 56px) with breathing room */
    <div className="dish-info-overlay fixed top-16 sm:top-20 left-0 right-0 z-ar pointer-events-none">
      <div className="container mx-auto px-3 sm:px-4 md:px-6 lg:px-8">
        <div className="dish-info-card bg-card/95 backdrop-blur-sm rounded-xl shadow-warm-xl border border-border p-2.5 sm:p-4 md:p-6 pointer-events-auto">
          <div className="flex items-start justify-between gap-2 sm:gap-4">
            <div className="flex-1 min-w-0">
              <h1 className="text-sm sm:text-xl md:text-2xl lg:text-3xl font-heading font-semibold text-foreground mb-1 sm:mb-2 line-clamp-2 leading-snug">
                {dishName}
              </h1>
              
              <div className="flex items-center gap-2 mb-1.5 sm:mb-3">
                <span className="inline-flex items-center gap-1 sm:gap-1.5 px-2 sm:px-3 py-0.5 sm:py-1 bg-primary/10 text-primary rounded-full text-xs font-caption font-medium">
                  <Icon name="Tag" size={11} />
                  {category}
                </span>
              </div>

              {/* Stats: 2-col on mobile, 3-col on md+ */}
              <div className="grid grid-cols-2 md:grid-cols-3 gap-1 sm:gap-3 md:gap-4">
                {servingSize && (
                  <div className="flex items-center gap-1 sm:gap-1.5 text-muted-foreground">
                    <Icon name="Users" size={12} className="flex-shrink-0" />
                    <span className="text-xs font-caption truncate">{servingSize}</span>
                  </div>
                )}
                
                {prepTime && (
                  <div className="flex items-center gap-1 sm:gap-1.5 text-muted-foreground">
                    <Icon name="Clock" size={12} className="flex-shrink-0" />
                    <span className="text-xs font-caption truncate">{prepTime}</span>
                  </div>
                )}
              </div>
            </div>

            <div className="flex-shrink-0 text-right">
              <div className="text-lg sm:text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-primary whitespace-nowrap">
                ${price}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DishInfoOverlay;